/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  SectionTitle,
  container
} from "../common";

const arrowRightIcon = `${WealthyEnv.BROKING_CDN_URL}/arrow-right-blue.png`;
const promoImage = `${WealthyEnv.BROKING_CDN_URL}/why-wealthy-broking-banner-image.png`;
const stackRuppeeIcon = `${WealthyEnv.BROKING_CDN_URL}/stack-ruppee-icon.png`;
const diamondIcon = `${WealthyEnv.BROKING_CDN_URL}/diamond-icon.png`;
const pricingIcon = `${WealthyEnv.BROKING_CDN_URL}/best-pricing-icon.png`;
const familyIcon = `${WealthyEnv.BROKING_CDN_URL}/family-account-icon.png`;
const tradingIcon = `${WealthyEnv.BROKING_CDN_URL}/seamless-trading-icon.png`;
const superAppIcon = `${WealthyEnv.BROKING_CDN_URL}/super-app-icon.png`;

const WhyWealthyBroking = ({
  featuresList,
  partnerData
}) => {
  const isPartnerValid = partnerData?.name ? true : false;
  return (
    <>
      <BrokerageSection>
        <SectionTitle>Why Wealthy Broking?</SectionTitle>
        <WealthyFeaturesWrapper>
          <WealthyFeaturesList>
            {
              featuresList.map((item, index) => (
                isPartnerValid && index === 1 ? null : (
                  <FeatureItemWrapper key={index}>
                    <FeatureDetail>
                      <FeatureName>{item.name}</FeatureName>
                      <FeatureInfo>{item.info}</FeatureInfo>
                    </FeatureDetail>
                    {
                      item?.url ? (
                        <FeatureLink href={item.url}>
                          {item.urlText}
                        </FeatureLink>
                      ) : ("")
                    }
                  </FeatureItemWrapper>
                )
              ))
            }
          </WealthyFeaturesList>
          <FeatureImageWrapper>
            <FeatureImage
              alt="default-image"
              src={promoImage}
            />
          </FeatureImageWrapper>
        </WealthyFeaturesWrapper>
      </BrokerageSection>
    </>
  );
};

const BrokerageSection = styled(container)`
  margin-top: 10rem;
  position: relative;

  @media (max-width: 576px) {
    margin-bottom: 7rem;
  }
`;

const WealthyFeaturesWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 6rem;

  & > div {
    flex: 1;
  }

  @media (max-width: 576px) {
    padding-top: 3.2rem;
  }
`;

const WealthyFeaturesList = styled.div``;

const FeatureItemWrapper = styled.div`
  padding-left: 68px;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 4.6rem;

  &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 0;
    background-image: url(${stackRuppeeIcon});
    height: 52px;
    width: 52px;
    background-size: cover;
  }

  &:nth-child(1) {
    &::before {
      background-image: url(${diamondIcon});
    }
  }

  &:nth-child(2) {
    &::before {
      background-image: url(${pricingIcon});
    }
  }

  &:nth-child(3) {
    &::before {
      background-image: url(${familyIcon});
    }
  }

  &:nth-child(4) {
    &::before {
      background-image: url(${tradingIcon});
    }
  }

  &:nth-child(5) {
    &::before {
      background-image: url(${superAppIcon});
    }
  }

  &:last-child {
    margin-bottom: unset;
  }

  @media (max-width: 576px) {
    padding-left: 40px;
    margin-bottom: 3.2rem;

    &::before {
      height: 24px;
      width: 24px;
    }
  }
`;

const FeatureDetail = styled.div``;

const FeatureName = styled.h3`
  font-size: 2.4rem;

  @media (max-width: 576px) {
    font-size: 1.8rem;
  }
`;

const FeatureInfo = styled.div`
  font-size: 1.6rem;
  color: ${colors.textGray};

  @media (max-width: 576px) {
    font-size: 1.2rem;
  }
`;

const FeatureLink = styled.a`
  display: block;
  color: ${colors.primary};
  border-radius: 100px;
  border: 1px solid #DDD;
  width: fit-content;
  padding: 0 1.5rem;
  position: relative;
  padding-right: calc(10px + 2rem);
  font-size: 1.6rem;
  transition: all 0.15s ease-in-out;
  margin-left: 2.1rem;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 1.5rem;
    height: 1rem;
    width: 1rem;
    transform: translateY(-50%);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${arrowRightIcon});
  }

  &:hover{
    background-color: rgb(103, 37, 244, 0.04);
  }

  @media (max-width: 576px) {
    font-size: 1.4rem;
  }
`;

const FeatureImageWrapper = styled.div`
  width: 100%;

  @media (max-width: 576px) {
    display: none;
  }
`;

const FeatureImage = styled.img`
  width: 100%;
  object-fit: cover;
`;

export default WhyWealthyBroking;
